import { defaultApiInstance } from '@/compositions/api';

export function getEventsList(params) {
  return defaultApiInstance.get(`v1/calendar`, { params });
}
